commusoftCommon.filter('diaryEventTimeFormat', function (CS_LANGUAGE) {
    return function (dateString) {
        if (dateString == '') {
            return '';
        }
        moment.locale(CS_LANGUAGE);
        //check for diff zone uk for default +01:00
        return moment(dateString).format('hh:mm a')
    };
});